'use strict';

var GraphTypes = require('consts').HeatCharacteristicTypes;
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var SVG = require('utils/svg');

var backTemp = 'backFlowTemperature';
var dayTemp = 'flowTemperatureDay';
var nightTemp = 'flowTemperatureNight';
var outTemp = 'outdoorTemperature';
var types = [backTemp, dayTemp, nightTemp];

var transformX = function (x) {
    // formular x:
    //  1. invert axis (switch -40°C with +20°C)
    //  2. shift origin [-400,200] -> [0,600]
    //  3. stretch by factor 2.5
    //  4. add coordinate system offset (x=100)
    // this.transformX(tuple[0])+400)*2.5+100
    return (SVG.invertAxis(x, -400, 200) + 400) * 2.5 + 100;
};

var inverseTransformX = function (x) {
    return SVG.invertAxis((x - 100) / 2.5 - 400, 200, -400);
};

var transformY = function (y) {
    // formular y:
    //   1. invert (switch 200 with 1500)
    //   2. shift origin [200, 1500] -> [0, 1300]
    //   2. add coordinate system offset (y=100)
    return SVG.invertAxis(y, 200, 1500) - 200 + 100;
};

var inverseTransformY = function (y) {
    return SVG.invertAxis(y + 100, 1500, 200);
};

var FourPointCharacteristicView = Backbone.Marionette.ItemView.extend({
    template: require('components/devices/templates/controller/characteristic_layout'),

    ui: function () {
        // gurantee unique IDs in the dom, even with multiple view-instances
        var suffix = this.options.circuitNr;
        suffix += this.options.readOnly ? '-readonly' : '';
        this.prefix = '#js-graph-' + suffix;
        return {
            svg: this.prefix,
            helplineX: this.prefix + ' #js-horizontal-help-line',
            helplineY: this.prefix + ' #js-vertical-help-line',
            helplineBackgroundY: this.prefix + ' #y-help-background',
            helplineBackgroundX: this.prefix + ' #x-help-background',
            labelX: this.prefix + ' #js-horizontal-label',
            labelY: this.prefix + ' #js-vertical-label',
            dragPoints: this.prefix + ' .js-point',
            dragGroup: this.prefix + ' #drag-visualization',
            polylines: this.prefix + ' .js-polyline',
            maxLine: this.prefix + ' #js-max-line',
            minLine: this.prefix + ' #js-min-line',
            maxText: this.prefix + ' #js-max-text',
            minText: this.prefix + ' #js-min-text',
            limits: this.prefix + ' #js-limits',
            min: '#min-' + suffix,
            max: '#max-' + suffix,
            maxBackground: this.prefix + ' #js-max-background',
            minBackground: this.prefix + ' #js-min-background',
            grid: this.prefix + ' #js-grid-container',
            clipDay: this.prefix + ' #coordinate-system-flow-' + suffix + '>rect',
            clipBack: this.prefix + ' #coordinate-system-backflow-' + suffix + '>rect',
            charLine: this.prefix + ' .js-char-line',
            currentTemp: this.prefix + ' #js-current-temp',
        };
    },

    events: {
        'mousedown .draggable': 'initDrag',
        'touchstart .draggable': 'initDrag',
        'mousedown @ui.limits': 'initDragLimit',
        'touchstart @ui.limits': 'initDragLimit',
        mousemove: 'doDrag',
        touchmove: 'doDrag',
        'change .js-edit-value': 'editValue',
        'change .js-limits': 'editLimits',
        'click .js-set-type': 'setType',
        'click .js-char-line': 'setLine',
    },

    currentTemperatureColor: '#e219c9',

    initialize: function (options) {
        this.readOnly = options.readOnly;
        this.values = options.values;
        this.graphType = this.values.getType();
        this.flowType = this.values.get('flowType');
        if (this.readOnly) {
            this.events = {};
        }
        $(window).on('mouseup', $.proxy(this.finishDrag, this));
        $(window).on('touchend', $.proxy(this.finishDrag, this));
    },

    serializeData: function () {
        var outdoorTemperature = this.values.getValue('currentTemperature').val;
        var data = { config: {} };
        var dashStyle = '0';
        var strokeWidth = '5';
        if (outdoorTemperature === 32767) {
            data.noTemp = { color: this.currentTemperatureColor };
            data.noTemp.val = this.values.getValue('currentSetPoint').val / 10;
            data.noTemp.val = 50;
            data.noTemp.y = transformY(data.noTemp.val * 10);
            dashStyle = '20,20';
            strokeWidth = '3';
        }
        data.isBackFlow = this.flowType === backTemp;
        // current temperatur
        data.temp = { x: transformX(outdoorTemperature), text: outdoorTemperature / 10 };
        data.temp.textPosX = Misc.clamp(transformX(outdoorTemperature), 450, 1400);

        // current flow temperatur set by the controller
        data.flowTemp = this.getCurrentTemp();

        data.limit = this.getLimits();
        // color of the current flow type
        data.color = this.getColor();
        data.flowTypes = [
            { name: i18n.TR('Vorlauf'), id: dayTemp, selected: this.flowType === dayTemp, key: 't' },
            { name: i18n.TR('Vorlauf'), id: nightTemp, selected: this.flowType === nightTemp, key: 'n' },
            { name: i18n.TR('Rücklauf'), id: backTemp, selected: this.flowType === backTemp, key: 'r' },
        ];

        if (this.graphType === GraphTypes.FourPoint) {
            // 4-Punkte-Kennlinie
            data.currentName = this.values.getValue(this.flowType + '0').name;
            data.graphTemplate = 'CHARACTERISTIC_4_POINT_GRAPH';
            data.configTemplate = 'CHARACTERISTIC_4_POINT_CONFIG';
            data.plotData = { polylines: this.initPolylines(), dashstyle: dashStyle, strokeWidth: strokeWidth };
            data.config.values = _.zip(this.values.getPointValues(outTemp), this.values.getPointValues(this.flowType), [
                'P1',
                'P2',
                'P3',
                'P4',
            ]);
            data.config.id = this.flowType;
            data.flowTypes[0].icon = 'wi wi-day-sunny';
            data.flowTypes[1].icon = 'fa fa-moon-o';
            if (!this.readOnly) {
                data = $.extend(data, this.initDragvisualization(this.flowType));
            }
        } else {
            // Steigungskennlinie
            data.currentName =
                this.flowType === 'backFlowTemperature' ? i18n.TR('Rücklauftemp.') : i18n.TR('Vorlauftemp.');
            data.graphTemplate = 'CHARACTERISTIC_GRADIENT_GRAPH';
            data.configTemplate = 'CHARACTERISTIC_GRADIENT_CONFIG';
            data.plotData = this.getSlopeGraphs();
            data.plotData.dashstyle = dashStyle;
            data.plotData.strokeWidth = strokeWidth;
            data.flowTypes[1].disabled = true;
            data.config.values =
                this.flowType === backTemp
                    ? _.pick(this.values.values, ['levelRegulation', 'gradientRegulation'])
                    : _.pick(this.values.values, [
                          'daySetpoint',
                          'nightSetpoint',
                          'levelHeatCircuit',
                          'gradientHeatCircuit',
                      ]);
        }

        data.readOnly = this.readOnly;
        if (this.readOnly) {
            data.configTemplate = 'PARAMETER_READ_ONLY';
            switch (this.values.getType()) {
                case GraphTypes.FourPoint:
                    data.values = [
                        { name: this.values.getPoints(outTemp)[0].name, values: this.values.getPoints(outTemp) },
                        { name: this.values.getPoints(dayTemp)[0].name, values: this.values.getPoints(dayTemp) },
                        { name: this.values.getPoints(nightTemp)[0].name, values: this.values.getPoints(nightTemp) },
                        { name: this.values.getPoints(backTemp)[0].name, values: this.values.getPoints(backTemp) },
                    ];
                    break;
                case GraphTypes.Gradient:
                    data.parameter = {
                        title: [i18n.TR('Vorlauf'), i18n.TR('Rücklauf')],
                        gradient: [
                            this.values.getValue('gradientHeatCircuit'),
                            this.values.getValue('gradientRegulation'),
                        ],
                        level: [this.values.getValue('levelHeatCircuit'), this.values.getValue('levelRegulation')],
                        setPointDay: this.values.getValue('daySetpoint'),
                        setPointNight: this.values.getValue('nightSetpoint'),
                    };
                    break;
                case GraphTypes.ConstantValue:
                    break;
            }
            data.limits = {
                flow: _.pick(this.values.values, ['minFlowTemp', 'maxFlowTemp']),
                backflow: _.pick(this.values.values, ['minBackFlowTemp', 'maxBackFlowTemp']),
            };
        }
        data.circuitNr = this.options.circuitNr;
        data.axisColor = 'grey';
        data.labelColor = 'black';
        return data;
    },

    onRender: function () {
        // marionette adds an extra div. Let's use it as grid container :)
        $(this.el).addClass('gc-2-1');
        if (this.readOnly) {
            $(this.el).addClass('read-only');
        }
    },

    onShow: function () {
        if (!this.readOnly) {
            if (this.graphType === GraphTypes.FourPoint) {
                SVG.addClass($(this.prefix + ' .js-polyline'), 'inactive');
                SVG.removeClass(this.ui.polylines.filter('#js-polyline-' + this.flowType), 'inactive');
            }
        }
        // clip all characteristic lines at the upper and lower limit
        if (this.graphType === GraphTypes.Gradient) {
            this.clipGraph();
        }
    },

    onBeforeDestroy: function () {
        $(window).off('mouseup', $.proxy(this.finishDrag, this));
        $(window).off('touchend', $.proxy(this.finishDrag, this));
    },

    // updateFromChart updates the values of the model, specified by the id with the a pair of coordinates.
    updateFromChart: function (id, index, coordinate) {
        if (id === outTemp) {
            this.values.setOutdoorTemperature(index, inverseTransformX(coordinate));
        } else {
            this.values.setValue(id + index, inverseTransformY(coordinate));
        }
    },

    // returns the correct decimal presentation
    getDisplayValue: function (id, index) {
        var value = this.values.getValue(id + index).val;
        return value / 10;
    },

    // converts the value to the corresponding svg coordinates
    getSVGCoordinates: function (id, idx) {
        if (id.startsWith(outTemp)) {
            return transformX(this.values.getValue(id + idx).val);
        }
        return transformY(this.values.getValue(id + idx).val);
    },

    getAllSVGCoordinates: function () {
        var result = {
            x: [],
            flowTemperatureDay: [],
            flowTemperatureNight: [],
            backFlowTemperature: [],
        };
        _.each(this.values.getPointValues(outTemp), function (val) {
            result.x.push(transformX(val));
        });
        _.each(this.values.getPointValues(dayTemp), function (val) {
            result.flowTemperatureDay.push(transformY(val));
        });
        _.each(this.values.getPointValues(nightTemp), function (val) {
            result.flowTemperatureNight.push(transformY(val));
        });
        _.each(this.values.getPointValues(backTemp), function (val) {
            result.backFlowTemperature.push(transformY(val));
        });

        return result;
    },

    editLimits: function (e) {
        var id = e.target.id.split('-')[0];
        var isMin = id === 'min';
        var type = this.flowType === backTemp ? 'BackFlowTemp' : 'FlowTemp';

        var value = parseFloat(e.target.value);
        if (isNaN(value)) {
            return;
        }
        this.values.setLimit(value * 10, isMin);
        e.target.value = this.values.getValue(id + type).val / 10;
        this.updateLimits();
    },

    getLimits: function () {
        // min and max are too close? -> offset maxTextPos
        var offset = Math.abs(this.values.max() / 10 - this.values.min() / 10) < 5 ? -25 : 25;

        var max = transformY(this.values.max());
        var min = transformY(this.values.min());
        return {
            max: max,
            maxTextPos: max + offset,
            maxTextBackgroundPos: max + offset - 50,
            maxText: this.values.max() / 10,
            min: min,
            minTextPos: min + 25,
            minTextBackgroundPos: min + 25 - 50,
            minText: this.values.min() / 10,
        };
    },

    // inits helplines, drag-points and labels
    initDragvisualization: function () {
        var dragPoints = [];
        for (var i = 0; i < 4; i++) {
            dragPoints.push({
                x: transformX(this.values.getValue(outTemp + i).val),
                y: transformY(this.values.getValue(this.flowType + i).val),
            });
        }

        return {
            dragPoints: dragPoints,
            color: this.getColor(), // currently chosen characteristic
            horizontal: {
                line: {
                    x2: dragPoints[0].x,
                    y: dragPoints[0].y,
                },
                label: {
                    y: dragPoints[0].y,
                    value: this.getDisplayValue(this.flowType, 0),
                },
            },
            vertical: {
                line: {
                    x: dragPoints[0].x,
                    y2: dragPoints[0].y,
                },
                label: {
                    x: dragPoints[0].x,
                    value: this.getDisplayValue(outTemp, 0),
                },
            },
        };
    },

    // returns the path for all characteristic lines
    initPolylines: function () {
        var polyConfig = [];
        var coord = this.getAllSVGCoordinates();
        _.each(
            types,
            function (type) {
                polyConfig.push({
                    color: this.getColor(type),
                    points: this.toPolyLinePath(_.zip(coord.x, coord[type]), type),
                    type: type,
                    inactive: this.flowType !== type,
                });
            },
            this
        );
        return polyConfig;
    },

    // updateSVG updates all graphical elements affected from the given parameter
    updateSVG: function () {
        // update polylines
        if (this.graphType === GraphTypes.FourPoint) {
            var coord = this.getAllSVGCoordinates();
            _.each(
                types,
                function (type) {
                    $(this.prefix + ' #js-polyline-' + type)[0].setAttribute(
                        'points',
                        this.toPolyLinePath(_.zip(coord.x, coord[type]), type)
                    );
                },
                this
            );
            var type = this.flowType;
            var idx = this.currentDragID;
            var x = this.getSVGCoordinates(outTemp, idx);
            var y = this.getSVGCoordinates(type, idx);

            // update dragPoint:
            var point = this.ui.dragPoints[idx];
            point.setAttribute('cx', x);
            point.setAttribute('cy', y);

            // update helplines
            this.ui.helplineX[0].setAttribute('x2', x);
            this.ui.helplineX[0].setAttribute('y1', y);
            this.ui.helplineX[0].setAttribute('y2', y);
            this.ui.helplineY[0].setAttribute('x1', x);
            this.ui.helplineY[0].setAttribute('x2', x);
            this.ui.helplineY[0].setAttribute('y2', y);

            // update labels
            this.ui.labelX[0].setAttribute('y', y + 25);
            this.ui.labelX[0].textContent = this.getDisplayValue(type, idx) + ' °C';
            this.ui.labelY[0].setAttribute('x', x);
            this.ui.labelY[0].textContent = this.getDisplayValue(outTemp, idx) + ' °C';

            // label white background
            this.ui.helplineBackgroundX[0].setAttribute('x', x - 80);
            this.ui.helplineBackgroundY[0].setAttribute('y', y - 25);
        }

        if (this.graphType === GraphTypes.Gradient) {
            this.updateGradientGraphs();
        }
        this.updateCurrentTemp();
    },

    updateCurrentTemp: function () {
        // update current "Vorlauftemperatur"
        var currentTemp = this.getCurrentTemp();
        if (currentTemp === undefined) {
            return;
        }

        // current temperatur label overlapps with limit? -> shift
        var limits = this.getLimits();
        var shift = 0;
        if (Math.abs(currentTemp.y - limits.max) < 50) {
            shift = -Math.abs(currentTemp.y - limits.max) - 50;
        }
        if (Math.abs(currentTemp.y - limits.min) < 50) {
            shift = Math.abs(currentTemp.y - limits.min) + 50;
        }

        var elements = this.ui.currentTemp.children();
        elements[0].setAttribute('y1', currentTemp.y);
        elements[0].setAttribute('y2', currentTemp.y);
        elements[0].setAttribute('x2', currentTemp.x);
        // text and label
        elements[1].setAttribute('y', currentTemp.y - 25 + shift);
        elements[2].setAttribute('y', currentTemp.y + 25 + shift);
        elements[2].textContent = currentTemp.value;
    },

    setType: function (e) {
        var id = e.currentTarget.id;
        if (this.graphType === GraphTypes.Gradient && id === nightTemp) {
            // there is no dedicated graph for the night flow setpoint
            return;
        }

        // update buttons
        this.flowType = id;
        $(this.prefix + ' .js-set-type').removeClass('btn-inverse');
        $(this.prefix + ' .js-set-type').addClass('btn-white');
        $(this.prefix + ' #' + this.flowType).addClass('btn-inverse');
        $(this.prefix + ' #' + this.flowType).removeClass('btn-white');

        this.values.set('flowType', this.flowType);
        this.render();

        // update color
        if (this.graphType === GraphTypes.FourPoint) {
            this.ui.dragGroup[0].setAttribute('stroke', this.getColor());
            this.ui.dragGroup[0].setAttribute('fill', this.getColor());
        }

        // update min/max
        this.updateLimits();
    },

    updateLimits: function () {
        var limits = this.getLimits();
        this.ui.limits[0].setAttribute('fill', this.getColor());
        this.ui.limits[0].setAttribute('stroke', this.getColor());
        this.ui.maxLine[0].setAttribute('y1', limits.max);
        this.ui.maxLine[0].setAttribute('y2', limits.max);
        this.ui.maxText[0].setAttribute('y', limits.maxTextPos);
        this.ui.maxText[0].textContent = 'max ' + limits.maxText + ' °C';
        this.ui.maxBackground[0].setAttribute('y', limits.maxTextBackgroundPos);
        this.ui.minLine[0].setAttribute('y1', limits.min);
        this.ui.minLine[0].setAttribute('y2', limits.min);
        this.ui.minText[0].setAttribute('y', limits.minTextPos);
        this.ui.minBackground[0].setAttribute('y', limits.minTextBackgroundPos);
        this.ui.minText[0].textContent = 'min ' + limits.minText + ' °C';
        this.ui.min.val(limits.minText);
        this.ui.max.val(limits.maxText);

        if (this.graphType === GraphTypes.Gradient) {
            this.updateGradientGraphs();
        }
        this.clipGraph();
        this.updateCurrentTemp();
    },

    updateGradientGraphs: function () {
        // update slope-characteristics
        _.each(
            this.getSlopeGraphs(),
            function (slope, idx) {
                var elements = $(this.prefix + ' #js-line-' + idx).children();
                elements[0].setAttribute('d', slope.path);
                elements[0].setAttribute('clip-path', slope.clippath);
                elements[1].setAttribute('d', slope.path);
                elements[1].setAttribute('clip-path', slope.clippath);
                elements[2].textContent = slope.label.text;
                elements[2].setAttribute('x', slope.label.x);
                elements[2].setAttribute('y', slope.label.y);
                // lower continuation
                elements[3].setAttribute('y1', slope.start.y);
                elements[3].setAttribute('y2', slope.start.y);
                elements[3].setAttribute('opacity', slope.start.show * slope.opacity);
                elements[3].setAttribute('x2', slope.start.x);
                // upper continuation
                elements[4].setAttribute('x1', slope.end.x);
                elements[4].setAttribute('y1', slope.end.y);
                elements[4].setAttribute('y2', slope.end.y);
                elements[4].setAttribute('opacity', slope.end.show * slope.opacity);
            },
            this
        );
    },

    initDrag: function (e) {
        // todo: Eigentlich sollten alle Events tot sein.... :(
        if (this.readOnly) {
            return;
        }
        this.dragging = true;
        var id = parseInt(e.target.id.split('-')[2]);
        if (isNaN(id)) {
            return;
        }
        this.currentDragID = id;
        this.updateSVG();
        this.updateForm();
        this.ui.dragGroup[0].setAttribute('class', '');
    },

    initDragLimit: function (e) {
        // todo: Eigentlich sollten alle Events tot sein.... :(
        if (this.readOnly) {
            return;
        }
        this.limitDragging = true;
        var prefix = e.target.id.split('-')[1];
        this.limitID = prefix + 'FlowTemp';
        if (this.flowType === backTemp) {
            this.limitID = prefix + 'BackFlowTemp';
        }
    },

    doDragLimit: function (e) {
        var position = Misc.getCoordinates(e);
        var pt = SVG.getSVGCoordinatesFromScreen(this.ui.svg[0], position.x, position.y);
        var y = Math.round(pt.y * 10) / 10;

        // only execute function, if new position is different enough e.g. "magnetic points".
        if (Math.abs(transformY(this.values.getValue(this.limitID)) / 10 - y) <= 10) {
            return;
        }

        y = Math.round(y / 10) * 10;

        // update limits
        var newLimit = inverseTransformY(y);

        var isMin = this.limitID.substring(0, 3) === 'min';
        this.values.setLimit(newLimit, isMin);
        // // max < min? -> abort!
        // if (this.limitID.substring(0,3) === 'max') {
        // 	if (newLimit - this.values.min() < 0) {
        // 		return;
        // 	}
        // } else {
        // 	if (this.values.max() - newLimit < 0) {
        // 		return;
        // 	}
        // }

        // was valid Limit? -> update svg elements
        if (newLimit == this.values.getValue(this.limitID).val) {
            this.updateLimits();
        }
    },

    finishDrag: function (e) {
        if (this.readOnly) {
            return;
        }
        this.limitDragging = false;
        if (this.graphType === GraphTypes.FourPoint) {
            this.ui.dragGroup[0].setAttribute('class', 'invisible');
        }
        this.currentDragID = undefined;
        this.dragging = false;
    },

    doDrag: function (e) {
        if (this.dragging === true) {
            this.doDragPoint(e);
        }
        if (this.limitDragging === true) {
            this.doDragLimit(e);
        }
    },

    doDragPoint: function (e) {
        var position = Misc.getCoordinates(e);
        var pt = SVG.getSVGCoordinatesFromScreen(this.ui.svg[0], position.x, position.y);
        var y = Math.round(pt.y * 10) / 10;
        var x = Math.round(pt.x * 10) / 10;

        // only execute function, if new position is different enough e.g. "magnetic points".
        if (
            Math.abs(this.values.getValue(outTemp + this.currentDragID).val - inverseTransformX(x)) <= 10 &&
            Math.abs(this.values.getValue(this.flowType + this.currentDragID).val - inverseTransformY(y)) <= 10
        ) {
            return;
        }
        // transform to values in °C -> round to ints -> transform back
        x = transformX(Math.round(inverseTransformX(x) / 10) * 10);
        y = transformY(Math.round(inverseTransformY(y) / 10) * 10);
        this.updateFromChart(outTemp, this.currentDragID, x);
        this.updateFromChart(this.flowType, this.currentDragID, y);

        this.updateSVG();
        this.updateForm();
    },

    updateForm: function () {
        $('#js-input' + this.currentDragID).val(this.getDisplayValue(this.flowType, this.currentDragID));
        $('#' + outTemp + this.currentDragID).val(this.getDisplayValue(outTemp, this.currentDragID));
    },

    editValue: function (e) {
        var id = e.target.id;
        var value = parseFloat(e.target.value);
        var dragID = parseInt(e.target.id.substring(e.target.id.length - 1));

        if (!isNaN(dragID)) {
            // only change dragID, if the changed inputfield is associated with a dragable element
            this.currentDragID = dragID;
        }
        if (isNaN(value)) {
            return;
        }
        var valueID = '';
        if (id.startsWith('js-input')) {
            valueID = this.flowType + this.currentDragID;
            this.values.setValue(valueID, value * 10);
        } else {
            if (id.startsWith('outdoorTemperature')) {
                this.values.setOutdoorTemperature(parseInt(id.substring(id.length - 1)), value * 10);
            } else {
                this.values.setValue(id, value * 10);
            }
            valueID = id;
        }
        // rewrite the parsed value to the input element
        e.target.value = this.values.getValue(valueID).val / 10;
        this.updateSVG();
    },

    // converts a set of coordinates to its corresponding polyline path
    toPolyLinePath: function (tuples, type) {
        var coord = '';
        var yMin = transformY(this.values.min(type));
        var yMax = transformY(this.values.max(type));
        _.each(tuples, function (tuple) {
            coord += tuple[0] + ' ' + tuple[1] + ' ';
        });
        // first point after 20 °C?-> continue with constant value
        if (tuples[3][0] > 100) {
            coord += ' 100 ' + tuples[3][1];
        }
        // last point before -40 °C?-> continue with constant value
        if (tuples[0][0] < 1600) {
            coord = '1600 ' + tuples[0][1] + ' ' + coord;
        }
        return coord;
    },

    getParameterFunction: function (parameter) {
        // original Funktion von Samson für die Vorlauftemperatur.
        // DER TEIL IN ECKIGEN KLAMMERN GILT NUR FÜR DEN VORLAUF. Für den Rücklauf wird t_soll=200 gesetzt:
        // f(t) = s/10*(240 - t^2/1000 - t ) - t/10 + 260 + [s/5*(t_soll-200)] + offset;
        // t = Außentemperatur
        // t_soll = Solltemperatur
        // s = Vorlauf-Steigung
        // offset gibt das Niveau (Versatz zur X-Achse) der Kurve an
        // 240, 260, 200 sind Temperaturen (24°, 26° und 20 °)

        var s = parameter.slope;
        var t_in = parameter.indoorDesiredValue;
        var offset = parameter.offset;
        return function (t_out) {
            return (
                (s / 10) * (240 - (t_out * t_out) / 1000 - t_out) - t_out / 10 + 260 + (s / 5) * (t_in - 200) + offset
            );
        };
    },

    // returns the outdoor temperatur of a characteristic for which the maximum flow temperature is reached or NaN if it is never reached
    getIntersectionsWithLimit: function (parameter, limit) {
        var s = parameter.slope;
        var t_in = parameter.indoorDesiredValue;
        // the formula comes from the equation limit = f(t), (see "getParameterFunction")
        // We calculate the intersection of the slope-characteristic and limit (a constant, either min or max flow-temperatur)
        var p = -500 * (1 + 1 / s);
        var q = 10000 * ((limit - 260) / s - t_in / 5 + 16 - parameter.offset / s);
        var x1 = p - Math.sqrt(p * p - q);
        var x2 = p + Math.sqrt(p * p - q);
        return [x1, x2];
    },

    getDerivedParameterFunction: function (parameter) {
        var s = parameter.slope;
        return function (t_out) {
            return (-2 * s * t_out) / 10000 - (s + 1) / 10;
        };
    },

    clipGraph: function () {
        // clipp all characteristic lines at the upper and lower limit
        this.ui.clipDay[0].setAttribute('y', transformY(this.values.max(dayTemp)));
        this.ui.clipDay[0].setAttribute('height', this.values.max(dayTemp) - this.values.min(dayTemp));
        this.ui.clipBack[0].setAttribute('y', transformY(this.values.max(backTemp)));
        this.ui.clipBack[0].setAttribute('height', this.values.max(backTemp) - this.values.min(backTemp));
    },

    // getPath returns the path of a bezier curve for a given characteristic
    getPath: function (func, derived) {
        // xstart = intersection of the curve with the minimum
        // xsend  = intersection of the curve with the maximum
        var x_start = 200;
        var x_end = -400;
        var x_intersect =
            (derived(x_start) * x_start - func(x_start) - (derived(x_end) * x_end - func(x_end))) /
            (derived(x_start) - derived(x_end));
        var y = transformY(derived(x_start) * (x_intersect - x_start) + func(x_start));
        return (
            'M' +
            transformX(x_start) +
            ' ' +
            transformY(func(x_start)) +
            'Q' +
            transformX(x_intersect) +
            ' ' +
            y +
            ' ' +
            transformX(x_end) +
            ' ' +
            transformY(func(x_end))
        );
    },

    // returns all parameters needed for the template to render a slope-characteristic
    getSlopeTemplateConfig: function (parameter, flowType) {
        var func = this.getParameterFunction(parameter);
        var x = this.getIntersectionsWithLimit(parameter, this.values.max(flowType))[1];
        var y = Math.max(100, transformY(func(-400)));
        if (isNaN(x)) {
            x = 1600;
        } else {
            x = transformX(x) - 50; // x-offset label
            y = transformY(this.values.max(flowType)) - 35; // y-offset label
        }

        x = Math.min(1600, x);
        return {
            path: this.getPath(func, this.getDerivedParameterFunction(parameter)),
            label: { x: x + 20, y: y + 20, text: (parameter.slope / 10).toFixed(1) },
            color: parameter.color || 'grey',
        };
    },

    getGraphContinuation: function (parameter, type) {
        var xStart = this.getIntersectionsWithLimit(parameter, this.values.min(type));
        var xEnd = this.getIntersectionsWithLimit(parameter, this.values.max(type));

        // intersection exists? (side note: isNaN(xStart[0]) <=> isNaN(xStart[1]))

        var showStart = isNaN(xStart[0]) ? 0 : 1;
        var showEnd = isNaN(xEnd[0]) ? 0 : 1;

        // intersections with lower limit do exists: -> choose the correct one
        if (showStart) {
            // Is one of the intersections greater than 100?
            var x1 = 100 < transformX(xStart[0]) ? Math.min(1600, transformX(xStart[0])) : false;
            var x2 = 100 < transformX(xStart[1]) ? Math.min(1600, transformX(xStart[1])) : false;
            // both intersection lie within the interval -> get the minimum.
            if (x1 !== false && x2 !== false) {
                xStart = Math.min(x1, x2);
            } else {
                // take the intersection inside the interval or 100, if both are outside.
                xStart = x1 || x2 || 100;
                // no intersection inside the interval ? -> hide line
                showStart = 0;
            }
        } else {
            // no intersection with lower limit? => slope is always below lower limit -> show constant
            xStart = 1601;
            showStart = 1;
        }
        // intersections with upper limit do exists: -> choose the correct one
        if (showEnd) {
            // Is one of the intersections smaller than 1600?
            var x1 = transformX(xEnd[0]) < 1600 ? Math.max(100, transformX(xEnd[0])) : false;
            var x2 = transformX(xEnd[1]) < 1600 ? Math.max(100, transformX(xEnd[1])) : false;
            // both intersection lie within the interval -> get the maximum.
            if (x1 !== false && x2 !== false) {
                xEnd = Math.max(x1, x2);
            }
            if (x1 !== false || x2 !== false) {
                xEnd = x1 || x2;
            }
            if (x1 === false && x2 === false) {
                xEnd = 1600;
                showEnd = 0;
            }
        } else {
            xEnd = 1600;
        }
        return {
            start: {
                x: xStart,
                y: transformY(this.values.min(type)),
                show: showStart,
            },
            end: {
                x: xEnd,
                y: transformY(this.values.max(type)),
                show: showEnd,
            },
        };
    },

    // returns an array of parameters for all slope-characteristics and their labels
    getSlopeGraphs: function () {
        // create defaultcharacteristic lines and labels
        var clipPath =
            this.flowType === dayTemp
                ? 'url(#coordinate-system-flow-' + this.options.circuitNr
                : 'url(#coordinate-system-backflow-' + this.options.circuitNr;
        clipPath += this.readOnly ? '-readonly)' : ')';
        var characteristicLines = [];
        var parameter = {
            indoorDesiredValue: this.flowType === backTemp ? 200 : this.values.getValue('daySetpoint').val,
            offset:
                this.flowType === backTemp
                    ? this.values.getValue('levelRegulation').val
                    : this.values.getValue('levelHeatCircuit').val,
        };

        if (!this.readOnly) {
            for (var slope = 2; slope < 33; slope += 2) {
                parameter.slope = slope;
                var continuation = this.getGraphContinuation(parameter, this.flowType);
                characteristicLines.push(
                    $.extend(
                        { clippath: clipPath, slope: slope, opacity: 0.4 },
                        this.getSlopeTemplateConfig(parameter, this.flowType),
                        continuation
                    )
                );
            }
        }
        // configured slope for the flow temperatur day time
        var parameter = {
            slope: this.values.getValue('gradientHeatCircuit').val,
            indoorDesiredValue: this.values.getValue('daySetpoint').val,
            offset: this.values.getValue('levelHeatCircuit').val,
            color: 'red',
        };

        var continuation = this.getGraphContinuation(parameter, dayTemp);
        var clipDay = 'url(#coordinate-system-flow-' + this.options.circuitNr;
        clipDay += this.readOnly ? '-readonly)' : ')';
        characteristicLines.push(
            $.extend(
                { clippath: clipDay, opacity: this.flowType === backTemp ? 0.4 : 1 },
                this.getSlopeTemplateConfig(parameter, dayTemp),
                continuation
            )
        );

        // configured slope for the flow temperatur night time
        parameter = {
            slope: this.values.getValue('gradientHeatCircuit').val,
            indoorDesiredValue: this.values.getValue('nightSetpoint').val,
            offset: this.values.getValue('levelHeatCircuit').val,
            color: 'black',
        };

        var continuation = this.getGraphContinuation(parameter, nightTemp);
        var clipDay = 'url(#coordinate-system-flow-' + this.options.circuitNr;
        clipDay += this.readOnly ? '-readonly)' : ')';
        characteristicLines.push(
            $.extend(
                { clippath: clipDay, opacity: this.flowType === backTemp ? 0.4 : 1 },
                this.getSlopeTemplateConfig(parameter, dayTemp),
                continuation
            )
        );

        // configured slope for the back flow temperatur
        parameter = {
            slope: this.values.getValue('gradientRegulation').val,
            indoorDesiredValue: 200,
            offset: this.values.getValue('levelRegulation').val,
            color: 'blue',
        };
        var clipBack = 'url(#coordinate-system-backflow-' + this.options.circuitNr;
        clipBack += this.readOnly ? '-readonly)' : ')';
        continuation = this.getGraphContinuation(parameter, backTemp);
        characteristicLines.push(
            $.extend(
                { clippath: clipBack, opacity: this.flowType === backTemp ? 1 : 0.4 },
                this.getSlopeTemplateConfig(parameter, backTemp),
                continuation
            )
        );
        // create configured lines and labels
        return characteristicLines;
    },

    getColor: function (flowType) {
        flowType = flowType || this.flowType;
        switch (flowType) {
            case dayTemp:
                return 'red';
            case nightTemp:
                return 'black';
            case backTemp:
                return 'blue';
        }
    },

    setLine: function (e) {
        var gradient = parseInt(e.currentTarget.getAttribute('gradient'));
        if (isNaN(gradient)) {
            return;
        }
        var id = this.flowType === dayTemp ? 'gradientHeatCircuit' : 'gradientRegulation';
        this.values.setValue(id, gradient);
        var gradient = this.values.getValue(id).val / 10;
        this.updateGradientGraphs();
        this.updateCurrentTemp();
        $('#' + id).val(gradient);
    },

    getValues: function (circuitNr) {
        return this.values.getAllWriteableValues(circuitNr);
    },

    // getCurrentTemp calculatese the intersection of the current outdoor temperatur with the active flow function
    getCurrentTemp: function () {
        var outdoorTemperature = this.values.getValue('currentTemperature').val;

        if (outdoorTemperature === 32767) {
            return undefined;
        }
        var result = { x: transformX(outdoorTemperature) };
        if (this.graphType === GraphTypes.FourPoint) {
            var smIdx = -10;
            var lgIdx = -10;
            var smaller = 0;
            var larger = 0;
            var y;
            var values = this.values.getPointValues(this.flowType);
            var outdoorTemperatures = this.values.getPointValues(outTemp);
            for (var i = 0; i < 4; i++) {
                if (outdoorTemperature <= outdoorTemperatures[i]) {
                    if (i === 0) {
                        // the outdoor Temperatur is smaller than the smallest point
                        y = values[0];
                    } else {
                        larger = outdoorTemperatures[i];
                        smaller = outdoorTemperatures[i - 1];
                        lgIdx = i;
                        smIdx = i - 1;
                    }
                    break;
                }
            }

            // all values greater than outdoor temperatur? -> y equals last value
            if (y === undefined && lgIdx === -10) {
                y = values[3];
            }
            if (y === undefined) {
                var slope = (values[lgIdx] - values[smIdx]) / (larger - smaller);
                y = values[smIdx] + slope * (outdoorTemperature - smaller);
            }
        } else {
            var slope = this.flowType === dayTemp ? 'gradientHeatCircuit' : 'gradientRegulation';
            var parameter = { slope: this.values.getValue(slope).val };
            if (this.flowType === backTemp) {
                parameter.indoorDesiredValue = 200;
                parameter.offset = this.values.getValue('levelRegulation').val;
            } else {
                parameter.indoorDesiredValue = this.values.getValue('daySetpoint').val;
                parameter.offset = this.values.getValue('levelHeatCircuit').val;
            }
            var func = this.getParameterFunction(parameter);
            y = func(outdoorTemperature);
        }
        // restrict value to upper and lower bound
        y = Math.round(Misc.clamp(y, this.values.min(), this.values.max()));
        result.y = transformY(y);
        result.value = y / 10 + ' °C';
        return result;
    },
});

module.exports = FourPointCharacteristicView;
